import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingSmlouvaTisk = lazy(() =>
  import('@/modules/leasing/LeasingSmlouvaTisk').then((m) => ({ default: m.LeasingSmlouvaTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/smlouvy/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <LeasingSmlouvaTisk />
    </Suspense>
  ),
});
